// Plain learner words for work set outside a lesson. Never shows ids, policy
// names or internal statuses.

const PURPOSE = {
  homework: "Homework",
  practice: "Practice",
  assessment: "Test",
  classroom: "Class work",
};

export const purposeLabel = (purpose) => PURPOSE[purpose] || "Work";

const day = (iso) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
};

// "Due Fri 7 Nov", or nothing when there is no due date.
export const dueLabel = (dueAt) => (dueAt ? `Due ${day(dueAt)}` : null);

export const doneLabel = (completedAt) => (completedAt ? `Finished ${day(completedAt)}` : "Finished");
